import TextArea from "components/atoms/input/TextArea";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import * as s from "styles/ModalCommonStyled";
import { AddWrapper } from "styles/ModalCommonStyled";
import { ValidateWord } from "components/atoms/text/Text";
import BigButton from "components/atoms/buttons/BigButton";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { useCallback, useRef, useState } from "react";
import { TaWrapper, UploadWrapper } from "./AboutStyled";
import MapUpload from "components/atoms/input/upload/map/MapUpload";
import { useMutation } from "react-query";
import { postIssue } from "api/helpAPI";
import { useAppSelector } from "redux/hooks";
import useApiError from "hook/useApiError";
import { checkEmpty } from "utils/functions";

interface Props {
  onModal: () => void;
  fileInfo?: string;
}
export function IssueReport(props: Props): JSX.Element {
  const imgRef = useRef<any>();
  const [text, setText] = useState<string>("");
  const [imgFile, setImgFile] = useState<any>("");
  const [uploadFile, setUploadFile] = useState<File>();
  const [validateMsg, setValidateMsg] = useState<string>("");
  const { notifySuccess, notifyError, lang, intlString } = useApiError();

  const accountId: string = useAppSelector(
    (state) => state.accountSettings.accountId
  );

  const saveImgFile = (e: any) => {
    let files = e.target.files[0];
    setUploadFile(files);
    const reader = new FileReader();
    reader.readAsDataURL(files);
    return new Promise((resolve: any) => {
      reader.onload = () => {
        setImgFile(reader.result);
        resolve();
      };
    });
  };

  const onDeleteImgFile = () => {
    imgRef.current.value = "";
    setImgFile("");
  };

  const mutationIssue = useMutation(postIssue, {
    onSuccess: () => {
      notifySuccess(lang.validateMsg.help.about.success);
      props.onModal();
    },
    onError: () => {
      notifyError(lang.validateMsg.help.about.fail);
    },
  });

  const onClickSave = useCallback(() => {
    if (checkEmpty(text)) {
      setValidateMsg(intlString(lang.validateMsg.help.about.emptyIssue));
      return;
    } else {
      setValidateMsg("");
    }
    const formData = new FormData();
    if (imgFile !== undefined && imgFile !== "" && uploadFile !== undefined) {
      formData.append("file", uploadFile as File);
    }
    const request = {
      issue: text,
    };
    const json = JSON.stringify(request);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("issue", blob);
    mutationIssue.mutate({
      form: formData, // Account -> UpdateRequest
      accountId: accountId,
    });
  }, [accountId, imgFile, mutationIssue, text, uploadFile]);

  return (
    <BigPopupTemplate title="Report An Issue" onModal={props.onModal}>
      <AddWrapper>
        <s.Row>
          <ModalInput label="Describe the issue in detail" essential>
            <TaWrapper>
              <TextArea
                placeholder="Please enter a message."
                onChange={(e) => setText(e.target.value)}
                data-testid="help-about-about-textarea-set-text"
              />
            </TaWrapper>
            <ValidateWord data-testid="help-about-about-validate-word">
              {validateMsg}
            </ValidateWord>
          </ModalInput>
        </s.Row>
        <s.Row>
          <UploadWrapper>
            {/* <Text>Upload File</Text> */}
            <MapUpload
              onUpload={saveImgFile}
              onDelete={onDeleteImgFile}
              ref={imgRef}
            />

            {/* <input
                type="file"
                id="logoUPload"
                accept="image/png"
                onChange={logoHandleChange}
               /> */}
          </UploadWrapper>
        </s.Row>
      </AddWrapper>
      <s.ButtonWrapper>
        <BigButton
          id="dw_about_issue_cancel"
          buttonType="cancel"
          label="Cancel"
          onClickBtn={props.onModal}
          data-testid="help-about-about-issue-cancel-modal"
        />

        <BigButton
          id="dw_about_issue_save"
          label="Save"
          onClickBtn={onClickSave}
          data-testid="help-about-about-issue-save-click-save"
        />
      </s.ButtonWrapper>
    </BigPopupTemplate>
  );
}
